__turbopack_context__.v({
  "className": "y6Jm7q_className",
  "variable": "y6Jm7q_variable",
});
